import React, { useEffect } from "react"
import { connect } from "react-redux"
import { css } from "@emotion/react"
import { globalHistory } from "@reach/router"
import { Link, navigate } from "gatsby"

import { ChannelWrapper } from "../styled"
import theme from "../../theme"

//import { CHANNELS } from "../../utils/general"

import { toggleExpanded, updateQuery, changeChannel } from "../../actions"

const ChannelTile = (props) => {
  const { toggleExpanded, updateQuery, expanded } = props

  const channelPath = props.channel.name === "Home" ? "/" : props.channel.path

  const isActive =
    (props.channel.name === "Home" && props.currentChannel === "") ||
    props.currentChannel === props.channel.name

  const borderCSS = css`
    border-bottom: ${isActive ? `solid 2px ${theme.color.green}` : "none"};
    color: ${isActive ? `#2D2D2D` : "#737273"};
  `

  const handleClick = () => {
    props.changeChannel(props.channel.name)
    localStorage.setItem("channel", props.channel.name)
    navigate(channelPath)
    if (expanded) {
      toggleExpanded(!expanded)
      updateQuery("")
    }
  }

  return (
    <ChannelWrapper onClick={handleClick}>
      <Link to={channelPath} tabIndex={1}>
        <p css={borderCSS}>{props.channel.name}</p>
      </Link>
    </ChannelWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    expanded: state.searchBarExpandedReducer.expanded,
    currentChannel: state.channelReducer.currentChannel,
  }
}

export default connect(mapStateToProps, {
  toggleExpanded,
  updateQuery,
  changeChannel,
})(ChannelTile)
